module.exports = __webpack_public_path__ + "fk.svg?f508dc9cd8aa7151b11a6f9230a90575";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/fk.svg
// module id = 998
// module chunks = 27